import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import SolicitacaoService from "../../services/resource/solicitacaoService";
import { useAuth } from "../../context/authContext";

const service = new SolicitacaoService();

// GET /pendentes já traz só o que está comigo OU com um grupo meu (ainda não assumido).
// Aqui só separamos os dois grupos comparando com o usuário logado, para os indicadores.
export function useMinhasTarefas() {
    const { user } = useAuth();
    const [tarefas, setTarefas] = useState([]);
    const [loading, setLoading] = useState(true);

    const carregar = useCallback(() => {
        setLoading(true);
        service.listarPendentes()
            .then(res => setTarefas(res.data))
            .catch(error => {
                console.error("Erro ao listar tarefas pendentes", error);
            })
            .finally(() => setLoading(false));
    }, []);

    useEffect(() => {
        carregar();
    }, [carregar]);

    const pendentesComigo = tarefas.filter(t => t.responsavelAtualId === user?.id);
    const pendentesDoMeuGrupo = tarefas.filter(t => t.responsavelAtualId == null && t.grupoResponsavelAtualId != null);

    return { tarefas, pendentesComigo, pendentesDoMeuGrupo, loading, recarregar: carregar };
}
